module.exports = __webpack_public_path__ + "img/Nachrichten-300x55.1471464d.jpg";